import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import {
    setGlobalDispatch,
    setGlobalNavigate,
} from '../../services/ReactServiceContext';

export default function RouterInitializer() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        setGlobalDispatch(dispatch);
        setGlobalNavigate((to: string) => navigate(to));
    }, [dispatch, navigate]);

    return null;
}
